<template>
  <div class="d-flex flex-column mx-auto">
    <div class="mx-auto">
      <span class="">{{ label }}</span>
    </div>
    <div class="d-flex mx-auto">
      <v-btn
        icon
        class="mx-1 my-auto"
        color="secondary"
        @click="selectedNumber--"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-chip-group
        v-model="selectedNumber"
        color="secondary"
        mandatory
      >
        <v-chip
          v-for="number in numberOptions"
          :key="number"
          :value="number"
          outlined
          style="min-width: 42px;"
          class="justify-center"
        >
          {{ number }}
        </v-chip>
      </v-chip-group>
      <v-btn
        icon
        class="mx-1 my-auto"
        color="secondary"
        @click="selectedNumber++"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NumberPicker',
  props: {
    value: Number,
    label: String
  },
  data: () => ({}),
  computed: {
    selectedNumber: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    numberOptions: function () {
      const count = 9
      const min = 2
      // Calculate start so selectedNumber is in the middle (index 4)
      let start = this.selectedNumber - Math.floor(count / 2)

      // Enforce the minimum value constraint
      if (start < min) {
        start = min
      }

      const options = []
      for (let i = 0; i < count; i++) {
        options.push(start + i)
      }
      return options
    }
  }
}
</script>
